<template>
   <g>
      <path
         d="M4.575 1H2.3C1.95522 1 1.62456 1.13696 1.38076 1.38076C1.13696 1.62456 1 1.95522 1 2.3V6.2C1 6.37072 1.03363 6.53977 1.09896 6.69749C1.16429 6.85521 1.26005 6.99852 1.38076 7.11924C1.50148 7.23996 1.64479 7.33571 1.80251 7.40104C1.96023 7.46637 2.12928 7.5 2.3 7.5H4.575C4.74572 7.5 4.91477 7.46637 5.07249 7.40104C5.23021 7.33571 5.37352 7.23996 5.49424 7.11924C5.61496 6.99852 5.71071 6.85521 5.77604 6.69749C5.84137 6.53977 5.875 6.37072 5.875 6.2V2.3C5.875 1.95522 5.73804 1.62456 5.49424 1.38076C5.25044 1.13696 4.91978 1 4.575 1ZM4.575 10.75H2.3C1.95522 10.75 1.62456 10.887 1.38076 11.1308C1.13696 11.3746 1 11.7052 1 12.05V14.325C1 14.6698 1.13696 15.0004 1.38076 15.2442C1.62456 15.488 1.95522 15.625 2.3 15.625H4.575C4.91978 15.625 5.25044 15.488 5.49424 15.2442C5.73804 15.0004 5.875 14.6698 5.875 14.325V12.05C5.875 11.7052 5.73804 11.3746 5.49424 11.1308C5.25044 10.887 4.91978 10.75 4.575 10.75ZM12.7 1H10.425C10.0802 1 9.74956 1.13696 9.50576 1.38076C9.26196 1.62456 9.125 1.95522 9.125 2.3V4.575C9.125 4.91978 9.26196 5.25044 9.50576 5.49424C9.74956 5.73804 10.0802 5.875 10.425 5.875H12.7C13.0448 5.875 13.3754 5.73804 13.6192 5.49424C13.863 5.25044 14 4.91978 14 4.575V2.3C14 1.95522 13.863 1.62456 13.6192 1.38076C13.3754 1.13696 13.0448 1 12.7 1ZM12.7 9.125H10.425C10.0802 9.125 9.74956 9.26196 9.50576 9.50576C9.26196 9.74956 9.125 10.0802 9.125 10.425V14.325C9.125 14.6698 9.26196 15.0004 9.50576 15.2442C9.74956 15.488 10.0802 15.625 10.425 15.625H12.7C13.0448 15.625 13.3754 15.488 13.6192 15.2442C13.863 15.0004 14 14.6698 14 14.325V10.425C14 10.0802 13.863 9.74956 13.6192 9.50576C13.3754 9.26196 13.0448 9.125 12.7 9.125Z"
         stroke="white"
         stroke-miterlimit="10"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-dashboard',
         viewBox: '0 0 15 17',
         width: 15,
         height: 17,
         fill: 'none',
      };
   },
};
</script>
